<template>
  <innerPageContainer
    class="consult-special-list"
    :loadmore="false"
    :title="'最新入驻'"
    ref="innerPageContainer"
    :headerFix="true"
  >
    <div class="consult-special-list-bg" slot="bg"></div>
    <top />

    <div slot="radius" class="consult-special-list-scroll">
      <div class="consult-special-list-intro">
        <img
          src="../../images/consult/special/lastest-intro.png"
          alt="入驻咨询师介绍"
        />
      </div>
      <ad name="zixun-zuixin" class="consult-special-list-ad" />
      <list
        class="list"
        :list="list"
        :page="options.page"
        :size="options.size"
        @load="getTeacherList"
        ref="list"
      >
        <teacherItem
          v-for="v in list"
          :key="v.id"
          :item="v"
          :showPrice="false"
          :include="['created']"
        />
        <noTeacherState slot="none" />
      </list>
    </div>
  </innerPageContainer>
</template>

<script>
import listCommon from 'app/web/store/consult/listCommon.js'
import teacherItem from 'app/web/component/consult/listCommon/item.vue'
import innerPageContainer from 'component/consult/expert/innerPageContainer.vue'
import noTeacherState from 'component/consult/noTeacherState.vue'
import consultPageMixin from 'app/web/mixins/consult/page.js'
import top from 'app/web/component/consult/special/top.vue'
import list from 'app/web/component/common/list.vue'
import ad from 'app/web/component/common/ad.vue'

export default {
  mixins: [consultPageMixin],
  dataStore: [
    {
      store: listCommon.store,
      name: 'specialListCommon'
    }
  ],
  components: {
    innerPageContainer,
    teacherItem,
    noTeacherState,
    top,
    list,
    ad
  },
  data() {
    return {
      selectIndex: 0,
      selectVal: [0, 0, 0],
      showRuleModel: false,
      stickOffsetTop: 0
    }
  },
  preFetch({ store }) {
    store.commit('setMeta', {
      title: '最新入驻',
      keywords: '心理咨询,心理咨询师',
      description:
        '壹心理心理咨询师频道，遵循严格的心理咨询师审核标准，已邀请500位心理咨询师和心理医生入驻，通过视频、语音、咨询室等方式为您提供婚恋、家庭、儿童、职场等心理咨询服务。'
    })

    return store.dispatch('specialListCommon/updateTeacherList', {
      sort: 'jointime'
    })
  },
  computed: {
    list() {
      return this.$store.state['specialListCommon'].teacherList
    },
    shareConfig() {
      let _link = window.location.href.replace(
        document.location.origin,
        this.$mZXSafeOrigin
      )
      return {
        title: `最新入驻-壹心理咨询`,
        desc: `壹心理咨询师新势力。`,
        link: _link,
        imgUrl: `https://ossimg.xinli001.com/20190724/cd2c3853c483ae18128e2358dbf423f2.jpeg`
      }
    },

    options() {
      return this.$store.state.specialListCommon.options
    }
  },
  mounted() {
    this.$refs.innerPageContainer.getNavHeight().then(h => {
      this.stickOffsetTop = h
    })
    this.$bridge.setStatusBarStyle({ style: 1 })
  },
  methods: {
    teacherItemClick(v) {
      this.eventStat('点击咨询师')
      this.toTeacherPage({ ...v, waytype: 'pre' })
    },

    getTeacherList(page, callback) {
      this.$store
        .dispatch('specialListCommon/fetchTeacherList', {
          page,
          size: 10
        })
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            callback(data.length < 10)
          }
          if (page === 2) {
            this.$refs.list.finish() // 最多加载20个
          }
        })
    },

    filterBarUpdate(options) {
      this.$store.commit('specialListCommon/setOptions', options)
      this.$refs.list.refresh()
    }
  }
}
</script>

<style lang="scss">
.consult-special-list {
  &-scroll {
    padding-top: 30px;
    .list {
      min-height: 100vh;
    }
  }
  &-bg {
    background: #7e8cff;
    // height: 668px;
    height: 900px;
  }
  &-intro {
    padding: 0 30px;
  }
  .consult-inner-page-radius-container {
    min-height: calc(100vh + 0.5rem);
  }

  &-ad {
    margin-bottom: 0;
  }
}
</style>
